import { apiEndPoints, apiMethods } from '../../../utils/apiConstants'
import myPeeguAxios from '../../../utils/myPeeguAxios'
import { downloadExcel } from '../../../utils/utils'
import { getFriendlyApiError } from '../../../utils/apiErrorMessages'
import { updateAllIndividualRecords } from './individualCaseSlice'

function rejectFriendly(ThunkAPI, error, fallback) {
	return ThunkAPI.rejectWithValue(getFriendlyApiError(error, fallback))
}

export const getIndividualRecordsThunk = async ({ body }, ThunkAPI) => {
	try {
		const response = await myPeeguAxios[apiMethods.post](
			apiEndPoints.getIndividualRecords,
			body,
		)
		ThunkAPI.dispatch(updateAllIndividualRecords(response.data))
		return response.data
	} catch (error) {
		return rejectFriendly(
			ThunkAPI,
			error,
			'Could not load Individual Case records. Please try again.',
		)
	}
}

export const deleteIndividualRecordThunk = async ({ body }, ThunkAPI) => {
	try {
		const response = await myPeeguAxios[apiMethods.put](
			apiEndPoints.deleteIndividualRecord,
			body,
		)
		return response.data
	} catch (error) {
		return rejectFriendly(
			ThunkAPI,
			error,
			'Could not delete this Individual Case. Please try again.',
		)
	}
}

export const addStudentndividualRecordThunk = async ({ body }, ThunkAPI) => {
	try {
		const response = await myPeeguAxios[apiMethods.post](
			apiEndPoints.addStudentIndividualRecord,
			body,
		)
		return response.data
	} catch (error) {
		return rejectFriendly(
			ThunkAPI,
			error,
			'Could not save this Individual Case. Please review and try again.',
		)
	}
}

export const updateIndividualRecordThunk = async ({ body }, ThunkAPI) => {
	try {
		const response = await myPeeguAxios[apiMethods.put](
			apiEndPoints.updateIndividualRecord,
			body,
		)
		return response.data
	} catch (error) {
		return rejectFriendly(
			ThunkAPI,
			error,
			'Could not update this Individual Case. Please try again.',
		)
	}
}

export const fetchIndividualRecordThunk = async ({ row_id }, ThunkAPI) => {
	try {
		const response = await myPeeguAxios[apiMethods.get](
			`${apiEndPoints.fetchIndividualRecord}/${row_id}`,
		)
		return response.data
	} catch (error) {
		return rejectFriendly(
			ThunkAPI,
			error,
			'Could not open this Individual Case. Please try again.',
		)
	}
}

const fetchIndividualCaseForExcelDownload = async (body, download) => {
	try {
		const response = await myPeeguAxios[apiMethods.post](
			`${apiEndPoints.getIndividualRecords}${download ? '?downloadAndFilter=true' : ''}`,
			body,
		)
		return response.data
	} catch (error) {
		throw new Error(
			getFriendlyApiError(error, 'Could not download the Individual Case list. Please try again.'),
		)
	}
}

export const handleDownloadExcel = (body, download) => {
	return async () => {
		const classData = await fetchIndividualCaseForExcelDownload(
			body,
			download,
		)
		downloadExcel(classData, 'individualList.xlsx')
	}
}

export const bulkDeleteIndividualRecordThunk = async ({ body }, ThunkAPI) => {
	try {
		const response = await myPeeguAxios[apiMethods.post](
			apiEndPoints.bulkDeleteIndividualCase,
			body,
		)
		return response.data
	} catch (error) {
		return rejectFriendly(
			ThunkAPI,
			error,
			'Could not delete the selected Individual Cases. Please try again.',
		)
	}
}
